export const config = {
  // host: 'http://10.20.200.34:8030',
  // host: 'http://10.20.200.34:8030/pppapi',
  host: 'https://dnsg.ign.gob.ar/pppapi',
  // host: 'http://melpomenia.linkpc.net/ppp',
  instructivoLink: 'https://www.ign.gob.ar/archivos/ppp/Instructivo_compresion_descompresion_RINEX.pdf',
}